import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NestApiProvider } from '../../nest-api';
import { responseObj } from '../../nest-model/nest-model';


/*
  Generated class for the AccessManagementProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class Sf6EmployeeTrainingRecordProvider {

  module: string = '';
  model: string = 'sf6s/trainingrecord';

  constructor(
    public http: HttpClient,
    public nestApi: NestApiProvider
  ) {
    
  }
  
  trainerByEmpId(arrEmp: string[]) {
    const method: string = "GET";
    const model: string = this.model;
    const func: string = "trainerByEmpId";
    const params: any = {};
    const urlParams: any = { arrEmp: arrEmp };
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<responseObj<any>>(method, url, params, urlParams, body, contentType);
  }

  allprovider() {
    const method: string = "GET";
    const model: string = this.model;
    const func: string = "allprovider";
    const params: any = {};
    const urlParams: any = { };
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<responseObj<any>>(method, url, params, urlParams, body, contentType);
  }

  provider(skip: number, limit: number, textSearch: string) {
    const method: string = "GET";
    const model: string = this.model;
    const func: string = "provider";
    const params: any = {};
    const urlParams: any = { skip: skip, limit: limit, keyword: textSearch };
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<responseObj<any>>(method, url, params, urlParams, body, contentType);
  }

  add(param) {
    const method: string = "POST";
    const model: string = this.model;
    const func: string = "add";
    const params: any = param;
    const urlParams: any = { };
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<responseObj<any>>(method, url, params, urlParams, body, contentType);
  }

  edit(param) {
    const method: string = "POST";
    const model: string = this.model;
    const func: string = "edit";
    const params: any = param;
    const urlParams: any = { };
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<responseObj<any>>(method, url, params, urlParams, body, contentType);
  }

  delete(param) {
    const method: string = "POST";
    const model: string = this.model;
    const func: string = "delete";
    const params: any = param;
    const urlParams: any = { };
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<responseObj<any>>(method, url, params, urlParams, body, contentType);
  }

  updatePost(param) {
    const method: string = "POST";
    const model: string = this.model;
    const func: string = "updatePost";
    const params: any =  param || {};
    const urlParams: any = { };
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<responseObj<any>>(method, url, params, urlParams, body, contentType);
  }

  currency() {
    const method: string = "GET";
    const model: string = this.model;
    const func: string = "currency";
    const params: any = { };
    const urlParams: any = { };
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<responseObj<any>>(method, url, params, urlParams, body, contentType);
  }

  instructor(textSearch, limit, skip) {
    const method: string = "GET";
    const model: string = this.model;
    const func: string = "instructor";
    const params: any = { };
    const urlParams: any = { textSearch: textSearch, limit: limit, skip: skip };
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<responseObj<any>>(method, url, params, urlParams, body, contentType);
  }

  alltraincourse() {
    const method: string = "GET";
    const model: string = this.model;
    const func: string = "alltraincourse";
    const params: any = {};
    const urlParams: any = {  };
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<responseObj<any>>(method, url, params, urlParams, body, contentType);
  }

  traincourse(language: string, skip: number, limit: number, textSearch: string) {
    const method: string = "GET";
    const model: string = this.model;
    const func: string = "traincourse";
    const params: any = {};
    const urlParams: any = { language: language, skip: skip, limit: limit, keyword: textSearch };
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<responseObj<any>>(method, url, params, urlParams, body, contentType);
  }

  listing(empId: string, language: string) {
    const method: string = "GET";
    const model: string = this.model;
    const func: string = "listing";
    const params: any = {};
    const urlParams: any = { empId: empId, language: language };
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<responseObj<any>>(method, url, params, urlParams, body, contentType);
  }


  detail(trnrecordCode: string) {
    const method: string = "GET";
    const model: string = this.model;
    const func: string = "detail";
    const params: any = {};
    const urlParams: any = {trnrecordCode: trnrecordCode};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<responseObj<any>>(method, url, params, urlParams, body, contentType);
  }

}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-integrated/services/sf6-employeetrainingrecord.api.ts